import { memo } from "react"
const Header = ({ title='', children, ...props }) => {

    const today = new Date().toLocaleDateString('es-GT', { day: 'numeric', month: 'long', year: 'numeric', })

    return(
    <>
    <div className='mb-5 pt-0 flex justify-between border border-secundarioMira border-b-grisMira flex-wrap gap-5'>
        <div className='flex content-center mt-5 lg:mb-11'>
            {
                props.logo ?
                <props.logo
                className='h-11 w-11 mr-2 text-secundario'
                />
                : null
            }
            <h1 className='my-auto text-2xl font-semibold text-white'>
                {title}
            </h1>
        </div>
        {
            children
            ? children
            : <div className='mb-5 lg:mb-11 lg:mt-5 py-1 px-3 rounded-lg flex place-content-center'>
                <p className='my-auto text-white text-lg font-semibold'>
                    Fecha: {today}
                </p>
              </div>
        }
    </div>
    </>
    )
}

export default memo(Header)